import { rgba } from "color2k";

const colors = {
  gray: {
    "25": "#FCFCFD",
    "50": "#FAF9FC",
    "100": "#F2F2F7",
    "150": "#C6C7D8",
    "200": "#E4E4EC",
    "300": "#D0D1DD",
    "400": "#9998B3",
    "500": "#676685",
    "600": "#474A67",
    "700": "#373454",
    "800": "#1E1D39",
    "900": "#101828",
  },
  primary: {
    "25": "#F7FCF9",
    "50": "#EEF8F3",
    "100": "#E1F0E9",
    "200": "#CAE2D7",
    "300": "#B4CFC2",
    "400": "#8DB6A2",
    "500": "#6E9884",
    "600": "#366B58",
    "700": "#1C4431",
    "800": "#123726",
    "900": "#022715",
  },
  error: {
    "25": "#FFFBFA",
    "50": "#FEF3F2",
    "100": "#FEE4E2",
    "200": "#FECDCA",
    "300": "#FDA29B",
    "400": "#F97066",
    "500": "#F04438",
    "600": "#D92D20",
    "700": "#B42318",
    "800": "#912018",
    "900": "#7A271A",
  },
  warning: {
    "25": "#FFFCF5",
    "50": "#FFFAEB",
    "100": "#FEF0C7",
    "200": "#FEDF89",
    "300": "#FEC84B",
    "400": "#FDB022",
    "500": "#F79009",
    "600": "#DC6803",
    "700": "#B54708",
    "800": "#93370D",
    "900": "#7A2E0E",
  },
  eggplant: {
    "25": "#FFFCFF",
    "50": "#FAF3FA",
    "100": "#F3EAF3",
    "200": "#E7DBE7",
    "300": "#D8C7D8",
    "400": "#C2A9C3",
    "500": "#A07AA3",
    "600": "#895E8C",
    "700": "#714275",
    "800": "#4E2851",
    "900": "#320A35",
  },
  teal: {
    "25": "#F4FBFB",
    "50": "#E7F2F2",
    "100": "#D8ECEC",
    "200": "#C7E0E0",
    "300": "#A8C7C7",
    "400": "#88AFAF",
    "500": "#69A0A0",
    "600": "#468484",
    "700": "#276A6A",
    "800": "#0A4444",
    "900": "#023636",
  },
  cyan: {
    "25": "#ECFEFF",
    "50": "#DBFCFF",
    "100": "#A5F3FC",
    "200": "#79E4F2",
    "300": "#4BD4E9",
    "400": "#06B6D4",
    "500": "#0891B2",
    "600": "#0E7490",
    "700": "#155E75",
    "800": "#164E63",
    "900": "#0C394A",
  },
  blue: {
    "25": "#f5faff",
    "50": "#eff8ff",
    "100": "#d1e9ff",
    "200": "#b2ddff",
    "300": "#84caff",
    "400": "#53b1fd",
    "500": "#2e90fa",
    "600": "#1570ef",
    "700": "#175cd3",
    "800": "#1849a9",
    "900": "#194185",
  },
  indigo: {
    "25": "#f5f8ff",
    "50": "#eef4ff",
    "100": "#e0eaff",
    "200": "#c7d7fe",
    "300": "#a4bcfd",
    "400": "#8098f9",
    "500": "#6172f3",
    "600": "#444ce7",
    "700": "#3538cd",
    "800": "#2d31a6",
    "900": "#2d3282",
  },
  purple: {
    "25": "#fafaff",
    "50": "#f4f3ff",
    "100": "#ebe9fe",
    "200": "#d9d6fe",
    "300": "#bdb4fe",
    "400": "#9b8afb",
    "500": "#7a5af8",
    "600": "#6938ef",
    "700": "#5925dc",
    "800": "#4a1fb8",
    "900": "#3e1c96",
  },
  pink: {
    "25": "#fef6fb",
    "50": "#fdf2fa",
    "100": "#fce7f6",
    "200": "#fcceee",
    "300": "#faa7e0",
    "400": "#f670c7",
    "500": "#ee46bc",
    "600": "#dd2590",
    "700": "#c11574",
    "800": "#9e165f",
    "900": "#851651",
  },
  drawerOverlay: rgba(0, 0, 0, 0.05),
};

export default colors;
